import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { TrainingAttempt } from "@/lib/api/training-simulator/training-simulator";
import { cn } from "@/lib/utils";
import { InformationCircleIcon } from "@heroicons/react/24/outline";
import * as PopoverPrimitive from "@radix-ui/react-popover";
import { Moodies } from "@somethings-ui/core/assets";
import { useRef, useState } from "react";

export function LevelInfo({
  level,
  accentClassName,
}: {
  level: Pick<
    TrainingAttempt["level"],
    "position" | "title" | "module" | "context_copy"
  >;
  accentClassName?: string;
}) {
  const [open, setOpen] = useState(false);
  const closeTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

  const handleOpen = () => {
    if (closeTimer.current) {
      clearTimeout(closeTimer.current);
      closeTimer.current = null;
    }
    setOpen(true);
  };

  const handleClose = () => {
    closeTimer.current = setTimeout(() => setOpen(false), 120);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <div
          className="flex min-w-0 items-center gap-3"
          onMouseEnter={handleOpen}
          onMouseLeave={handleClose}
        >
          <div
            className={cn(
              "flex size-8 shrink-0 items-center justify-center rounded-full",
              accentClassName,
            )}
          >
            <img
              src={Moodies.blackSmileyMini}
              alt=""
              aria-hidden
              className="size-6"
            />
          </div>
          <div className="flex min-w-0 flex-col">
            <div className="mb-1 flex items-center gap-1">
              <span className="truncate text-body-3 text-text-secondary">
                Level {level.position} · {level.title}
              </span>
              <InformationCircleIcon className="size-4 stroke-[2px]" />
            </div>
            <span className="truncate text-body-4 text-text-tertiary">
              Module {level.module.position} · {level.module.title}
            </span>
          </div>
        </div>
      </PopoverTrigger>
      <PopoverPrimitive.Portal>
        <PopoverContent
          align="start"
          side="bottom"
          sideOffset={8}
          collisionPadding={16}
          className="z-[100] min-w-[500px]"
          onMouseEnter={handleOpen}
          onMouseLeave={handleClose}
        >
          <div className="flex flex-col">
            <h3 className="mb-4 text-header-4">
              What’s happening in this level
            </h3>
            <p className="whitespace-pre-line text-body-2">
              {level.context_copy}
            </p>
          </div>
        </PopoverContent>
      </PopoverPrimitive.Portal>
    </Popover>
  );
}
